import { useMemo } from 'react';
import { printManager, printerSelectors } from '@provider/print';
import { ComponentFrameworkContextMenu } from '@utils/component-framework';
import { makeOpgavekompleksetPrintSection } from '../../page.print/_make-print-section.js';
import { useShareWithTeacherAction } from '../../state/actions/share.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function OpgavekompleksetContextMenu(props) {
  const onShareWithTeacher = useShareWithTeacherAction(props.component.entryKey, props.onShareWithTeacher);
  const getPrintInput = useMemo(() => async () => {
    await printManager.preparePrint(`opgavekomplekset-${Math.random()}`, "export-service", {
      format: "A4-portrait",
      debug: false,
      sections: [makeOpgavekompleksetPrintSection(props.component)]
    });
    return document.querySelector(printerSelectors.container()) ?? document.body;
  }, [props.component]);
  const onPrint = async () => {
    const titleElement = document.querySelector("title");
    const originalTitle = titleElement?.textContent;
    if (titleElement) {
      titleElement.textContent = props.component.envelope.Title;
    }
    await printManager.preparePrint(`opgavekomplekset-${Math.random()}`, "browser", {
      format: "A4-portrait",
      debug: false,
      sections: [makeOpgavekompleksetPrintSection(props.component)]
    });
    printManager.triggerPrintDialog({
      afterPrint: () => {
        if (titleElement && originalTitle) {
          titleElement.textContent = originalTitle;
        }
      }
    });
  };
  return /*#__PURE__*/jsxs(ComponentFrameworkContextMenu, {
    enabled: true,
    className: props.className,
    axis: "horisontal",
    layout: "fab",
    nodeId: undefined,
    children: [/*#__PURE__*/jsx(ComponentFrameworkContextMenu.Button, {
      type: "export",
      printOrientation: "portrait",
      targets: {
        pdf: true,
        word: false
      },
      componentTitle: props.component.envelope.Title,
      input: getPrintInput
    }), /*#__PURE__*/jsx(ComponentFrameworkContextMenu.Button, {
      type: "drive",
      format: "pdf",
      componentTitle: props.component.envelope.Title,
      entryKey: props.component.entryKey,
      input: getPrintInput,
      printOrientation: "portrait"
    }), /*#__PURE__*/jsx(ComponentFrameworkContextMenu.Button, {
      type: "print",
      onClick: onPrint
    }), /*#__PURE__*/jsx(ComponentFrameworkContextMenu.Button, {
      type: "share",
      entryKey: props.component.entryKey,
      onShareWithTeacher: onShareWithTeacher
    })]
  });
}

export { OpgavekompleksetContextMenu };
//# sourceMappingURL=context-menu.js.map
